<template>
  <div>
    <navbar />
    <div class="min-h-screen flex flex-col bg-white lg:mx-64 py-8 px-4 lg:px-8">
      <div class="flex justify-end w-full mb-10">
        <badge>
          <font-awesome-icon :icon="['fas','filter']"/>
          Filtro
        </badge>
        <badge @click.stop="teste">
          <font-awesome-icon :icon="icon"/>
          <!-- <font-awesome-icon :icon="['fas','sort-up']"/> -->
          <!-- <font-awesome-icon :icon="['fas','sort-down']"/> -->
          Sort
        </badge>
      </div>

      <div class="flex flex-col space-y-6 jusfity-center w-full">
        <product-card 
          v-for="product in products" 
          :key="product.id" 
          :name="product.name"
          :tags="product.tags"
          :status="setStatus(product.valid_until)" 
        />
      </div>

      <add-btn />
    </div>
  </div>
</template>

<script>
import NavBar from '../components/NavBar/NavBar.vue'
import Badge from '../components/Badge.vue'
import ProductsCard from '../components/ProductsCard.vue';
import AddBtn from '../components/Buttons/Add.vue';

export default {
  name: 'Home',
  data: () => ({
    icon: ['fas','sort'],
    products: [
      {
        "id": 21,
        "name": "Biscoito Chocolate",
        "tags": [
          "Perecível",
          "Biscoito",
          "Chocolate"
        ],
        "valid_until": "2020-05-05",
        "manufactured_on": "2020-05-05",
        "codebar": "",
        "created_at": "2020-05-05",
        "updated_at": "2020-05-01"
      },
      {
        "id": 22,
        "name": "Biscoito de murango",
        "tags": [
          "Perecível",
          "Biscoito",
          "Morango"
        ],
        "valid_until": "2021-05-05",
        "manufactured_on": "2020-05-05",
        "codebar": "",
        "created_at": "2020-05-05",
        "updated_at": "2020-05-01"
      },
      {
        "id": 23,
        "name": "Iogurte",
        "tags": [
          "Perecível",
          "Biscoito",
          "Iogurte"
        ],
        "valid_until": "2020-10-11",
        "manufactured_on": "2020-05-05",
        "codebar": "",
        "created_at": "2020-05-05",
        "updated_at": "2020-05-01"
      }
    ]
  }),
  components: {
    'navbar': NavBar,
    'badge': Badge,
    'product-card': ProductsCard,
    'add-btn': AddBtn
  },
  methods: {
    setStatus(valid_until) {
      let date = new Date()
      let now = date.getFullYear()+'-' + (date.getMonth()+1) + '-'+date.getDate()

      if(valid_until >= now) return 'border-green-400'
      else return 'border-red-400'
    }
  }
}
</script>
